/**
 * The function `getDummyUser` returns dummy user data based on the user agent string provided.
 * @param userAgent - The `getDummyUser` function takes a `userAgent` parameter as input. This
 * parameter is typically a string that represents the user agent of a web browser making a request to
 * the server. The function then checks the user agent string to determine the type of browser and
 * returns dummy user information based on
 * @returns The `getDummyUser` function returns an object with properties based on the user agent
 * provided as a parameter. The object includes the user's name, email, group, id, image, and token.
 * The specific properties returned depend on the conditions set in the function for different user
 * agents (Chrome, Firefox, Safari, Edge, or default).
 */

/**
 * This code is used to test the user group assignment based on the browser's user agent.
 */
export function getDummyUser(userAgent) {

    if (!userAgent) return undefined;

    if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
      return {
        name: "Chrome User",
        email: "chrome@nine.com.au",
        group: "admin_user",
        id: "118307061843741949033",
        image: "/profile-img.png",
        token: "chrome-token"
      };
    } else if (userAgent.includes('Firefox')) {
      return {
        name: "Firefox User",
        email: "firefox@nine.com.au",
        group: "specialist_user",
        id: "14468423604492643395",
        image: "/profile-img.png",
        token: "firefox-token"
      };
    } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
      return {
        name: "Safari User",
        email: "safari@nine.com.au",
        group: "editor_user",
        id: "14468423604492643394",
        image: "/profile-img.png",
        token: "safari-token"
      };
    } else if (userAgent.includes('Edg')) {
      return {
        name: "Edge User",
        email: "edge@nine.com.au",
        group: "producer_user",
        id: "14468423604492643393",
        image: "/profile-img.png",
        token: "edge-token"
      };
    } else {
      return {
        name: "Default User",
        email: "default@nine.com.au",
        group: "standard_user",
        id: "14468423604492643392",
        image: "/profile-img.png",
        token: "default-token"
      };
    }
  }